import Immutable from 'immutable';

export default Immutable.fromJS({
  errors       : null,
  loaded       : { questions : {} },
  isActive     : false,
  isSaving     : false,
  isSuccessful : false,
});
